module.exports = __webpack_public_path__ + "static/media/bindEnterprise2.3e74c947.png";